import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexModule } from '@ngbracket/ngx-layout';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { ProgramCreateSurveysDrawerModule } from '@main-client/src/app/program-create-surveys-drawer/program-create-surveys-drawer.module';
import { ProgramTemplateFormModule } from '@main-client/src/app/program-template-form/program-template-form.module';

import { ProgramTemplatesBackend } from '@libs/src/backend/program-templates.backend';

import { CreateDevelopmentProgramTemplateComponent } from './create-development-program-template.component';

@NgModule({
  declarations: [CreateDevelopmentProgramTemplateComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatIconModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    NzBreadCrumbModule,
    NzDropDownModule,
    NzInputModule,
    NzFormModule,
    NzRadioModule,
    NzSkeletonModule,
    NzToolTipModule,
    NzTypographyModule,
    ProgramCreateSurveysDrawerModule,
    TtcButtonSharedModule,
    ProgramTemplateFormModule,
  ],
  exports: [CreateDevelopmentProgramTemplateComponent],
  providers: [ProgramTemplatesBackend],
})
export class CreateDevelopmentProgramTemplateModule {}
